/* eslint-disable react/destructuring-assignment */
import React from 'react'
import Iframe from 'gatsby-core-theme/src/components/atoms/iframe'
import { isTrackerLink } from 'gatsby-core-theme/src/helpers/tracker.mjs'
import processImageNode from './processImageNode.js'
import { TrackingKeys } from '~constants/tracking-api'
import PrettyLink from '~atoms/pretty-link'

export default (node, moduleWidth = 960, moduleName, pageTemplate, modulePosition, styles) => {

  if (node.name === 'a' && node?.attribs?.class) {
    node.attribs.class = styles && styles[node?.attribs?.class];
  }

  if (node && node.attribs && node.attribs['data-anchor-label']) {
    node.attribs['data-track'] = true;
  }

  if (node.name === 'div' && (node.attribs['data-type'] === 'columnBlock' || node.attribs['data-type'] === 'threeColumnBlock')) {
    node.attribs.class = `${styles.column} ${node.attribs?.class === 'two-column-block' ? styles.twoColumnBlock : styles.threeColumnBlock}`;
  }

  if (node.name === 'iframe') {
    return <Iframe src={node.attribs.src} />
  }

  if (node.name === 'img') {
    return processImageNode(node, moduleWidth)
  }

  if (node.name === 'a' && isTrackerLink(node?.attribs?.href || '')) {
    // Helper function to convert style string to an object
    const convertStyleStringToObject = (styleString) =>
      styleString.split(';').reduce((acc, style) => {
        const [key, value] = style.split(':')
        if (key && value) {
          acc[key.trim()] = value.trim()
        }
        return acc
      }, {})

    // Helper function to recursively render children nodes
    const renderChildren = (children) =>
      children.map((child) => {
        if (child.type === 'tag') {
          const styleObject = child.attribs?.style
            ? convertStyleStringToObject(child.attribs.style)
            : null

          const { style, ...attribsWithoutStyle } = child.attribs

          // Assuming `child.attribs.id` or a similar unique property exists
          const key = child.attribs.id || child.name

          if (child.name === 'img') {
            return processImageNode(child, moduleWidth)
          }

          return React.createElement(
            child.name,
            { key, ...attribsWithoutStyle, style: styleObject },
            child.name !== 'img' && child.name !== 'br'
              ? renderChildren(child.children || [])
              : null
          )
        }

        return child?.data
      })

    return (
      <PrettyLink
        directPrettyLink={node?.attribs?.href}
        pageTemplate={pageTemplate}
        moduleName={TrackingKeys?.CONTENT}
        tracker={module?.tracking_link_name || 'main'}
        className="content-module-gtm"
        clickedElement="link"
        rel={node?.attribs?.rel}
        modulePosition={modulePosition}
      >
        {node.children === 'text'
          ? node.children[0]?.data
          : renderChildren(node?.children || [])}
      </PrettyLink>
    )
  }

  if (node.name === 'p') {
    const hasChildImg = node?.children.find((child) => child?.name === 'img')

    if (hasChildImg) {
      hasChildImg.attribs.style = ''
      return hasChildImg
    }
  }

  // Add tab index for tables for accessibility
  if (node.name === 'table') {
    node.attribs.tabIndex = 0

    return node
  }

  return null
}
